import { useCallback } from 'react';
import useConfirmationDialog from 'src/components/ConfirmationDialog/view';
import { useContactsApi } from 'src/modules/contacts/api';
import { SpamContactDialogParams } from '../types';

export const useSpamContactDialogController = () => {
  const { markContactAsSpam } = useContactsApi();
  const { openDialog, ConfirmationDialog } = useConfirmationDialog();

  const handleContactMarkAsSpam = useCallback(
    ({ selectedCompanyId, contactId, isSpam, nextAction }: SpamContactDialogParams) => {
      const dialogConfig = !isSpam
        ? {
            title: `Mark contact as spam`,
            content: `By marking this contact as spam you will not see messages from the contact in your inbox.`,
            confirmButtonText: 'Mark as Spam',
          }
        : {
            title: `Remove contact from spam list`,
            content: `By removing this contact from spam list you will see messages from the contact in your inbox.`,
            confirmButtonText: 'Remove From Spam',
          };

      openDialog({
        ...dialogConfig,
        onConfirm: () => {
          markContactAsSpam(selectedCompanyId!, contactId, !isSpam).then(() => {
            nextAction?.();
          });
        },
      });
    },
    [markContactAsSpam, openDialog],
  );

  return {
    handleContactMarkAsSpam,
    SpamContactDialog: ConfirmationDialog,
  };
};
